export default __webpack_public_path__ + "static/media/agent.3ea312aa.png";